import { properDate } from './dateUtilities';

export const getPipelineMeta = (pipelines, pipeline_id) => {
  return (pipelines || []).length ? pipelines.find((el) => el.id === pipeline_id) : null;
};

export const getStageMeta = (stages, stage_id) => {
  return (stages || []).length ? stages.find((el) => el.id === stage_id) : {};
};

export const getPipelineLeadSortedMeta = (pipelineLead, lead, isFilter) => {
  const payload = {};
  let leadMeta = (lead || {}).meta || {};
  ['incoming', 'outgoing'].forEach((dir) => {
    const resultKey = dir === 'incoming' ? 'sortedIncoming' : 'sortedOutgoing';
    payload[resultKey] = Object.keys(leadMeta)
      .filter((el) => el.slice(0, 13) === `last_${dir}`)
      .map((key) => ({
        ...leadMeta[key],
        value: leadMeta[key].value || leadMeta[key].modification_datetime || leadMeta[key].creation_datetime,
      }))
      .sort((a, b) => {
        return new Date(properDate(b.value)).getTime() - new Date(properDate(a.value)).getTime();
      });
  });
  return payload;
};
